import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Collapse } from "reactstrap";
// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const VerticalLayout = (props) => {
  const { id } = useParams();
  const navData = navdata().props.children;
  const location = useLocation();

  /*
 layout settings
 */
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    (state) => ({
      leftsidbarSizeType: state.Layout.leftsidbarSizeType,
      sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
      layoutType: state.Layout.layoutType,
    })
  );

  //vertical and semibox resize events
  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (
        (sidebarVisibilitytype === "show" ||
          layoutType === "vertical" ||
          layoutType === "twocolumn") &&
        document.querySelector(".hamburger-icon")
      ) {
        document.querySelector(".hamburger-icon")?.classList.remove("open");
      } else {
        document.querySelector(".hamburger-icon")?.classList.add("open");
      }
    }
    // else if (windowSize < 1025 && windowSize > 767) {
    //   document.body?.classList.remove("twocolumn-panel");
    //   if (document.documentElement.getAttribute("data-layout") === "vertical") {
    //     document.documentElement.setAttribute("data-sidebar-size", "sm");
    //   }
    //   if (document.documentElement.getAttribute("data-layout") === "semibox") {
    //     document.documentElement.setAttribute("data-sidebar-size", "sm");
    //   }
    //   if (document.querySelector(".hamburger-icon")) {
    //     document.querySelector(".hamburger-icon")?.classList.add("open");
    //   }
    // }
    else if (windowSize < 1025 && windowSize <= 767) {
      document.body?.classList.remove("vertical-sidebar-enable");
      if (
        document.documentElement.getAttribute("data-layout") !== "horizontal"
      ) {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      if (document.querySelector(".hamburger-icon")) {
        document.querySelector(".hamburger-icon")?.classList.add("open");
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
      const ul = document.getElementById("navbar-nav");
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      let matchingMenuItem = document.getElementById(
        `${props.router.location.pathname.split("/")[1]}`
      );

      if (!matchingMenuItem)
        matchingMenuItem = itemsArray.find((x) => {
          return x.pathname === pathName;
        });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [props.router.location.pathname, props.layoutType]);

  function activateParentDropdown(item) {
    item?.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv?.classList.add("show");
      parentCollapseDiv.parentElement.children[0]?.classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          ?.classList.add("show");
        if (
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling?.classList.add("active");
        if (
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
        ) {
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
            ?.classList.add("show");
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
            .previousElementSibling?.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items) => {
    let actiItems = items.filter((x) => x?.classList.contains("active"));

    actiItems.forEach((item) => {
      if (item?.classList.contains("menu-link")) {
        if (!item?.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling?.classList.remove("show");
        }
      }
      if (item?.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling?.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item?.classList.remove("active");
    });
  };

  const isMenuItemIsActive = (item) => {
    if (!item.link) {
      return false;
    }

    const pathSegments = location.pathname.split("/").filter(Boolean);

    if (id) {
      if (item.link.includes(pathSegments[0])) {
        return true;
      }
    }

    if (item.subItems) {
      const isSubItemActiveResult = item.subItems.some((subItem) =>
        isSubItemActive(subItem)
      );
      if (isSubItemActiveResult) {
        return true;
      }
    }

    return location.pathname.includes(item.link);
  };

  const isSubItemActive = (item) => {
    if (location && location.pathname && item.link) {
      if (item.label.toLowerCase() === "employer groups") {
        return location.pathname.includes("employers");
      }
      if (item.label.toLowerCase() === "nationals") {
        return location.pathname.includes("national");
      }
      if (item.label.toLowerCase() === "admin dashboard") {
        return location.pathname.includes("dashboard-admin");
      }
      if (item.label.toLowerCase() === "member management") {
        return location.pathname.includes("member-management");
      }

      return location.pathname.includes(item.label.toLowerCase());
    }
    return false;
  };

  return (
    <React.Fragment>
      {/* menu Items */}
      <div style={{ overflowX: "hidden", overflowY: "auto" }}>
        {(navData || []).map((item, key) => {
          const isActive = isMenuItemIsActive(item);
          const isSubMenuActive = isSubItemActive(item);

          return (
            <React.Fragment key={key}>
              {item["isHeader"] ? (
                <li className="menu-title text-white mb-3">
                  <span data-key="t-menu ">{props.t(item.label)}</span>
                </li>
              ) : item.subItems ? (
                <li className="nav-item">
                  <Link
                    onClick={item.click}
                    className={`nav-link link-hover my-2 ms-0 align-items-center ${isMenuItemIsActive(item)
                      ? "menu-link2"
                      : "menu-link1 hover-target"
                      }`}
                    to={item.link ? item.link : "/"}
                    data-bs-toggle="collapse"
                    style={{
                      fontSize: "16px",
                      borderRadius: isMenuItemIsActive(item)
                        ? "0 10px 10px 0"
                        : "hover-target",
                      border: "0.5px solid var(--vz-secondary-border)",
                    }}
                  >
                    <img
                      src={
                        isMenuItemIsActive(item)
                          ? item.icon.active
                          : item.icon.inactive
                      }
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px",
                        stroke: isMenuItemIsActive(item) ? "black" : "white",
                      }}
                      className={`hover-target`}
                    />
                    <span
                      className={`hover-target
                    ${isMenuItemIsActive(item) ? "text-dark" : "link-hover"}
                      `}
                    >
                      {" "}
                      {props.t(item.label)}
                    </span>
                    {item.subItems && (
                      <i
                        className={`bx ms-5 hover-target 
                           ${isMenuItemIsActive(item)
                            ? "text-dark"
                            : "link-hover"
                          }
                          ${item.stateVariables
                            ? "bx-chevron-down"
                            : "bx-chevron-right"
                          }`}
                      ></i>
                    )}
                  </Link>
                  <Collapse
                    className="menu-dropdown"
                    isOpen={item.stateVariables}
                    id="sidebarApps"
                  >
                    <ul className=" nav-sm ms-n3 flex-column">
                      {item.subItems &&
                        (item.subItems || []).map((subItem, index) => (
                          <React.Fragment key={index}>
                            {!subItem.isChildItem ? (
                              <Link
                                to={subItem.link ? subItem.link : "/"}
                                className={`link-hover ${isSubItemActive(subItem)
                                  ? "active-subitem"
                                  : ""
                                  }`}
                              >
                                <li
                                  className={`d-flex py-0 ${isSubItemActive(subItem)
                                    ? "menu-link2 ms-n2"
                                    : "menu-link1"
                                    } ${index !== item.subItems.length - 1
                                      ? "mb-2"
                                      : ""
                                    }`}
                                  style={{
                                    listStyleType: "none",
                                    borderRadius: !isSubItemActive(subItem)
                                      ? "0 10px 10px 0"
                                      : "",
                                    border: !isSubItemActive(subItem)
                                      ? "1px solid var(--vz-secondary-border)"
                                      : "",
                                    borderLeft: isSubItemActive(subItem)
                                      ? "8px solid var(--vz-primary)"
                                      : "",
                                  }}
                                >
                                  <div
                                    className={`nav-link text-white py-0 d-flex`}
                                    style={{}}
                                  >
                                    <span
                                      className={`hover-target d-flex align-items-center py-1 pe-2 ${isSubItemActive(subItem)
                                        ? "text-dark"
                                        : "link-hover"
                                        }`}
                                    >
                                      <img
                                        src={
                                          isSubItemActive(subItem)
                                            ? subItem.icon.active
                                            : subItem.icon.inactive
                                        }
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          marginRight: "10px",
                                          stroke: isActive ? "black" : "white",
                                        }}
                                      // className={`hover-target ${
                                      //   isSubItemActive(subItem)
                                      //     ? "text-dark"
                                      //     : "link-hover"
                                      // }`}
                                      />

                                      <span style={{ fontSize: "12px" }}>
                                        {props.t(subItem.label)}

                                      </span>
                                    </span>
                                  </div>
                                  {subItem.badgeName ? (
                                    <span
                                      className={`badge badge-pill bg-${subItem.badgeColor}`}
                                      data-key="t-new"
                                    >
                                      {subItem.badgeName}
                                    </span>
                                  ) : null}
                                </li>
                              </Link>
                            ) : (
                              <li className="nav-item">
                                <Link
                                  onClick={subItem.click}
                                  className="nav-link text-white"
                                  to="/"
                                  data-bs-toggle="collapse"
                                >
                                  {" "}
                                  {props.t(subItem.label)}
                                </Link>
                                <Collapse
                                  className="menu-dropdown"
                                  isOpen={subItem.stateVariables}
                                  id="sidebarEcommerce"
                                >
                                  <ul className="nav nav-sm flex-column">
                                    {subItem.childItems &&
                                      (subItem.childItems || []).map(
                                        (childItem, key) => (
                                          <React.Fragment key={key}>
                                            {!childItem.childItems ? (
                                              <li className="nav-item">
                                                <Link
                                                  to={
                                                    childItem.link
                                                      ? childItem.link
                                                      : "/"
                                                  }
                                                  className="text-white link-hover"
                                                >
                                                  {props.t(childItem.label)}
                                                </Link>
                                              </li>
                                            ) : (
                                              <li className="text-white link-hover">
                                                <Link
                                                  to="/"
                                                  className=""
                                                  onClick={childItem.click}
                                                  data-bs-toggle="collapse"
                                                >
                                                  {props.t(childItem.label)}
                                                </Link>
                                                <Collapse
                                                  className="menu-dropdown"
                                                  isOpen={
                                                    childItem.stateVariables
                                                  }
                                                  id="sidebaremailTemplates"
                                                >
                                                  <ul className="nav nav-sm flex-column">
                                                    {childItem.childItems.map(
                                                      (subChildItem, key) => (
                                                        <li
                                                          className="text-white link-hover"
                                                          key={key}
                                                        >
                                                          <Link
                                                            to={
                                                              subChildItem.link
                                                            }
                                                            className="text-white link-hover"
                                                            data-key="t-basic-action"
                                                          >
                                                            {props.t(
                                                              subChildItem.label
                                                            )}{" "}
                                                          </Link>
                                                        </li>
                                                      )
                                                    )}
                                                  </ul>
                                                </Collapse>
                                              </li>
                                            )}
                                          </React.Fragment>
                                        )
                                      )}
                                  </ul>
                                </Collapse>
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                    </ul>
                  </Collapse>
                </li>
              ) : (
                <Link
                  className=" link-hover  "
                  id={item.id}
                  to={item.link ? item.link : "/"}
                >
                  <li
                    className={`nav-item d-flex my-2 py-0 ${isActive ? "menu-link2" : "menu-link1"
                      }`}
                    style={{
                      borderRadius: !isActive ? "0 10px 10px 0" : "",
                      border: "1px solid var(--vz-secondary-border)",
                      borderLeft: isActive ? "8px solid var(--nav-item-bl)" : "",
                      background: !isActive ? "var(--vz-secondary)" : "", // 👈 ADD THIS
                    }}
                  >
                    <div

                      className={`nav-link nav-item d-flex  py-2 ms-0 menu-link ${isActive ? "menu-link2" : "menu-link1"
                        }`}
                      style={{
                        borderRadius: isActive ? "0 10px 10px 0" : "",
                        background: !isActive ? "var(--vz-secondary)" : "", // 👈 ADD THIS

                      }}
                    >
                      <img
                        src={isActive ? item.icon.active : item.icon.inactive}
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "10px",
                          stroke: isActive ? "black" : "white",
                        }}
                        className={`hover-target ${item.icon} ${isActive ? "text-dark" : ""
                          }`}
                      />

                      <span
                        className={`hover-target pe-2 ${isActive ? "text-dark" : ""
                          }`}
                      >
                        {props.t(item.label)}
                      </span>
                    </div>
                  </li>
                </Link>
              )
              }
            </React.Fragment>
          );
        })}
      </div >
    </React.Fragment >
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
